import { type FailureSummary } from './failure-reasons';

type ReportToTestExecutor = (payload: {
  type: 'skip-test' | 'external-dependency-checkpoint';
  testName: string;
  summary: FailureSummary;
}) => void;

export { FailureReasons, type FailureSummary } from './failure-reasons';

/**
 * The following APIs are exposed by our playwright script.
 * These are only available when the app is loaded via playwright.
 */
declare global {
  // eslint-disable-next-line no-var
  var reportToTestExecutor: ReportToTestExecutor | undefined;
  // eslint-disable-next-line no-var
  var getTestName: () => Promise<string>;
}

class HostNotifier {
  public async reportExternalCheckpoint(potentialFailureSummary: FailureSummary) {
    if (!globalThis.reportToTestExecutor) {
      return;
    }

    const testName = (await globalThis.getTestName?.()) ?? 'default-test-name';
    globalThis.reportToTestExecutor({
      type: 'external-dependency-checkpoint',
      testName,
      summary: potentialFailureSummary,
    });

    console.log(`Reporting external checkpoint to test executor`, {
      summary: potentialFailureSummary,
    });
  }

  public async reportExternalFailure(summary: FailureSummary) {
    if (!globalThis.reportToTestExecutor) {
      return;
    }

    const testName = (await globalThis.getTestName?.()) ?? 'default-test-name';
    globalThis.reportToTestExecutor({
      type: 'skip-test',
      testName,
      summary,
    });

    console.log(`Reporting to test executor`, { summary });
  }
}

export const hostNotifier = new HostNotifier();
